// check OS dark theme
const IS_DARK_THEME = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
// set body class as 'dark'
IS_DARK_THEME && document.querySelector( 'body' ).classList.add( 'dark' );